import React, { useEffect, useState, useCallback } from 'react';
import SkeletonLoader from './components/AgendaContent/SkeletonLoader';

import { today, dbDateToTimestamp } from './utils/helpers';
import Filter from './Filter';

const App = ({ config, rootElement }) => {

	//state reflecting data and filtered data
	const [eventFeed, setEventFeed] = useState(null); //source data
	const [fetching, setFetching] = useState(true);

	//params available in dropdown for filter
	const [availableLocations, setAvailableLocations] = useState([]); //used for agenda
	const [availableDates, setAvailableDates] = useState([]); //used for agenda
	const [availableTags, setAvailableTags] = useState([]); //agenda = interests, cursus = genre
	const [availableAudiences, setAvailableAudiences] = useState([]); //used for both agenda and courses
	const [availableCategories, setAvailableCategories] = useState([]); //used for agenda

	/**
	 * @description	Fetching feed
	 */
	async function fetchData() {
		const response = await fetch(config.feedUrl);
		if (!response.ok) {
			const message = `An error has occured: ${response.status}`;
    		throw new Error(message);
		}
		const data = await response.json();
		// console.log(data);
		return data;
	};

  	/**
	 * @description	Retrieves available parameters for filtering from the feed + sets the state
	 * 					And adds a js date to the feed data
	 */
	const parseEventData = useCallback((data) => {
		const dataCopy = structuredClone(data);
		const allShowDays = [today];
		let daysCount = 1;
		let subsequentDay = new Date();
		while (config.minimum_days_in_filter && daysCount <= config.minimum_days_in_filter) {
			subsequentDay.setDate(subsequentDay.getDate() + 1);
			allShowDays.push(+new Date(subsequentDay.getFullYear(), subsequentDay.getMonth(), subsequentDay.getDate()));
			daysCount++;
		}
		const allLocations = [];
		const allTags = [];
		const allAudiences = [];
		const allCategories = [];
		const parsedData = [];

		Object.values(dataCopy).forEach((event) => {
			if (event?.times && event.times.length > 0) {
				event.times.map((show) => {

					if ( show?.location ) {
						!allLocations.some(location => Object.keys(location)[0] === Object.keys(show.location)[0]) && allLocations.push(show.location);
					}
					const timestamp = dbDateToTimestamp(show.program_start);
					allShowDays.indexOf(timestamp) === -1 && allShowDays.push(timestamp);
					show.date = timestamp;
					return show;
				});
			}

			//differentiate filters for agenda and courses


			if (event?.tags[config.tag_name] && Object.keys(event.tags[config.tag_name])?.length > 0) {
				Object.keys(event.tags[config.tag_name]).forEach((slug) => {
					!allTags.some(tag => Object.keys(tag)[0] === slug) && allTags.push({ [slug]: event.tags[config.tag_name][slug] });
				});
			}
			if (event?.tags?.audiences && Object.keys(event.tags.audiences).length > 0) {
				Object.keys(event.tags.audiences).forEach((slug) => {
					!allAudiences.some(audience => Object.keys(audience)[0] === slug) && allAudiences.push({ [slug]: event.tags.audiences[slug] });
				});
			}
			if (event?.tags?.categories && Object.keys(event.tags.categories).length > 0) {
				Object.keys(event.tags.categories).forEach((slug) => {
					!allCategories.some(category => Object.keys(category)[0] === slug) && allCategories.push({ [slug]: event.tags.categories[slug] });
				});
			}
			parsedData.push(event);
		});

		setAvailableLocations(allLocations);
		setAvailableDates(allShowDays.sort((a, b) => a - b));
		setAvailableTags(allTags);
		setAvailableAudiences(allAudiences);
		setAvailableCategories(allCategories);

		return parsedData;
	}, [config]);

	useEffect(() => {
		fetchData().then((data) => {
			setEventFeed(parseEventData(data[config.custom_post_type]));
			setFetching(false);
		});
	}, []);

	if (fetching) return <SkeletonLoader pageSize={config.pagination_pagesize} />;

	return (
		<Filter
			config={config}
			eventFeed={eventFeed}
			availableLocations={availableLocations}
			availableDates={availableDates}
			availableTags={availableTags}
			availableAudiences={availableAudiences}
			availableCategories={availableCategories}
			rootElement={rootElement}
		/>
	);
};

export default App;
